import { ReactNode } from "react";
import "./BaseTile.scss";

export const BaseTile = ({ children }: { children?: ReactNode }) => {
  return <div className="BaseTile">{children}</div>;
};
